import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  triggerCrumbClick,
  clearPendingCrumbClick,
} from '../../../redux/nav-breadcrumbs/navBreadcrumbsSlice';
import '../../../styles/NavigationBreadcrumb.scss';
import themeAssets from '../../../assets/theme-assets';

const NavigationBreadcrumb = ({ isMobile }) => {
  const dispatch = useDispatch();
  const { crumbs, pendingCrumbClick } = useSelector((store) => store.navBreadcrumb);
  const assets = themeAssets[process.env.REACT_APP_THEME_NAME];

  // Once LeftSideBar has consumed the pending click, clear it
  useEffect(() => {
    if (pendingCrumbClick) {
      // Small timeout ensures LeftSideBar's useEffect fires first
      const timer = setTimeout(() => dispatch(clearPendingCrumbClick()), 100);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [pendingCrumbClick, dispatch]);

  if (!crumbs || crumbs.length === 0) return null;

  const handleCrumbClick = (crumb, index) => {
    const isLast = index === crumbs.length - 1;
    if (isLast) return;
    // Dispatch to Redux — LeftSideBar listens and executes the navigation
    dispatch(triggerCrumbClick({ crumb, index }));
  };

  return (
    <nav className={`nav-breadcrumb ${(isMobile ? 'mobile' : '')}`} aria-label="Navigation">
      <ol className="nav-breadcrumb__list">
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <li key={crumb.id || crumb.label} className="nav-breadcrumb__item">
              {i > 0 && (
                <img
                  src={assets.arrowRight}
                  alt=""
                  className="nav-breadcrumb__sep"
                  aria-hidden="true"
                />
              )}
              {!isLast ? (
                <button
                  type="button"
                  className="nav-breadcrumb__link"
                  onClick={() => handleCrumbClick(crumb, i)}
                >
                  {crumb.label}
                </button>
              ) : (
                <span className="nav-breadcrumb__label nav-breadcrumb__label--current">
                  {crumb.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

NavigationBreadcrumb.propTypes = {
  isMobile: PropTypes.bool,
};

NavigationBreadcrumb.defaultProps = {
  isMobile: false,
};

export default NavigationBreadcrumb;
